import React, { useEffect, useState, useContext, useRef } from "react";
import style from "./ProcesElement.module.css";
import iconX from "assets/xDark.svg";
import iconTrash from "assets/trash2.svg";
import { AppContext } from "context/AppContext";
import { ModalInsertContext } from "context/ModalInsertContext";
import { addNewProcess } from "actions/addProcess";
import { _typ_elementu, reg_int } from "utils/initialvalue";
import { reg_txt } from "utils/initialvalue";
import { useHistoria } from "hooks/useHistoria";
import { getNameOfElement } from "actions/getNameOfElement";
import { useStatus } from "hooks/useStatus";
export default function ProcesElement({showElementyProcesyInsert}) {

if(showElementyProcesyInsert){
    return (
   <Window>
      <Header />
      <Table />
      <Footer />
   </Window>
  );
}

}


function Window({children}) {
  const modalContext = useContext(ModalInsertContext);
  return (
    <div className={style.blurContainer}>
      <div className={style.window}>{children}</div>
    </div>
  );
}


function Header() {
  const modalContext = useContext(ModalInsertContext);
  const appContext = useContext(AppContext);
  const rowElement = modalContext.selectedElementROW;
      const listaPapierow = appContext.listaPapierow;
    const listaPapierowWyszukiwarka = appContext.listaPapierowWyszukiwarka;

  const papier = (papier_id) => {


let nazwa = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.nazwa || ' '
let gramatura = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.gramatura || ' '
let wykonczenie = listaPapierowWyszukiwarka.find(x=> x.id == papier_id )?.wykonczenie || ' '

    return `${nazwa} ${gramatura} ${wykonczenie}  `
  }
  return (
    <div className={style.header}>
      <p className={style.title}>Procesy - <p className={style.title2}>{appContext.typ_elementu?.filter(x => x.id == rowElement?.typ)[0]?.nazwa} {rowElement?.naklad} szt. {rowElement?.nazwa} - {papier(rowElement?.papier_id)}</p> </p> 
      <Zamknij/>
    </div>
  );
}
function Zamknij() {
  const modalContext = useContext(ModalInsertContext);


  return (
    <img
      className={style.zamknij_icon}
      src={iconX}
      onClick={() => {
        modalContext.setShowElementyProcesyInsert(false);
 
      }}
      alt="Procesy"
    />
  );
}

function Footer() {
  const modalContext = useContext(ModalInsertContext);
  const setProcesyElementow = modalContext.setProcesyElementow;
  const procesyElementowTemporary = modalContext.procesyElementowTemporary;
    const contextModalInsert = useContext(ModalInsertContext);
    const elementy = contextModalInsert.elementy
    const daneZamowienia = contextModalInsert.daneZamowienia
    const [add] = useHistoria()
   const [setStatus] = useStatus()
  return (
    <div className={style.footer}>
      <button
        className={style.btn}
        onClick={() => {
          modalContext.setShowElementyProcesyInsert(false);
          setProcesyElementow(procesyElementowTemporary.map(row => {
            if(row.delete== true && row.historia != true){
              add(         {
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id,elementy,_typ_elementu)+ " - kasowanie procesu  ",
            zamowienie_id: daneZamowienia.id
          })
     setStatus(3)
          return {...row, historia: true}
            } 
      
            if(row.insert== true && row.historia != true && row.update != true){
              add(         {
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id,elementy,_typ_elementu)+ " - dodanie procesu  ",
            zamowienie_id: daneZamowienia.id
          })
     setStatus(3)
          return {...row, historia: true}
            } 
                  
            if(row.update== true && row.historia == false){
              add(         {
            kategoria: "Procesy",
            event: getNameOfElement(row.element_id,elementy,_typ_elementu)+ " - zmiana procesu  ",
            zamowienie_id: daneZamowienia.id
          })
     setStatus(3)
          return {...row, historia: true}
            } else return row


}))


        }}
      >
        Zapisz
      </button>
    </div>
  );
}

function Table() {
  const contexApp = useContext(AppContext);
  const contexModal = useContext(ModalInsertContext);
  const procesyElementowTemporary = contexModal.procesyElementowTemporary;
  const setProcesyElementowTemporary = contexModal.setProcesyElementowTemporary;
  const procesList = contexApp.procesList;
  const selectedElementROW = contexModal.selectedElementROW;

  // Filtrowana i posortowana lista
  const visibleRows = procesyElementowTemporary
    .filter(x => x.element_id === selectedElementROW.id)
    .filter(x => x.delete !== true)
    .sort((a, b) => (Number(a.indeks) || 0) - (Number(b.indeks) || 0));

  // Obsługa rozpoczęcia przeciągania – zapisujemy ID przeciąganego elementu
  const handleDragStart = (e, id) => {
    e.dataTransfer.setData("text/plain", id);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Wymagane, aby pozwolić na upuszczenie (drop)
    e.dataTransfer.dropEffect = "move";
  };

  // Obsługa upuszczenia elementu i przeliczenia indeksów
  const handleDrop = (e, targetRow) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("text/plain");

    if (draggedId === String(targetRow.id)) return;

    // Pobieramy element przeciągany i docelowy z widocznej listy
    const draggedIndex = visibleRows.findIndex(r => String(r.id) === draggedId);
    const targetIndex = visibleRows.findIndex(r => r.id === targetRow.id);

    if (draggedIndex === -1 || targetIndex === -1) return;

    // Przesuwamy element w lokalnej tablicy
    const reorderedList = [...visibleRows];
    const [draggedItem] = reorderedList.splice(draggedIndex, 1);
    reorderedList.splice(targetIndex, 0, draggedItem);

    // Przypisujemy nowe wartości 'indeks' (np. 1, 2, 3...)
    const updatedVisibleRowsMap = new Map(
      reorderedList.map((item, index) => [
        item.id,
        { ...item, indeks: index + 1, update: true }
      ])
    );

    // Aktualizujemy główny stan procesyElementowTemporary
    setProcesyElementowTemporary(prev =>
      prev.map(item => updatedVisibleRowsMap.get(item.id) || item)
    );
  };

  return (
    <div className={style.main}>
      <table className={style.table}>
        <thead>
          <tr>
            <th className={style.col_indeks}>#</th>
            <th className={style.col_indeks}>indeks</th>
            <th className={style.col_proces}>Proces</th>
            <th className={style.col_typ}>Typ</th>
            <th className={style.col_typ}>Ilość użytków</th>
            <th className={style.col_ilosc}>Front</th>
            <th className={style.col_ilosc}>Back</th>
            <th className={style.col_kolory}>Front kolory</th>
            <th className={style.col_kolory}>Back kolory</th>
            <th className={style.col_wersja}>Opis</th>
            <th className={style.col_wersja}></th>
          </tr>
        </thead>
        <tbody>
          {visibleRows.map((row, i) => {
            return (
              <tr
                key={row.id}
                draggable
                onDragStart={(e) => handleDragStart(e, row.id)}
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, row)}
                className={style.draggable_row}
              >
                <td style={{ cursor: "grab" }}>⠿ </td>
                <INDEKS row={row} />
                <ProcesName row={row} />
                <ProcessTyp row={row} />
                <IloscUzytkow row={row} />
                <FrontIlosc row={row} />
                <BackIlosc row={row} />
                <FrontKolor row={row} />
                <BackKolor row={row} />
                <Info row={row} />
                <Usun row={row} />
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className={style.dodaj_proces_row}>
        <button
          className={style.btn_dodaj_proces}
          onClick={() =>
            addNewProcess(
              selectedElementROW,
              procesyElementowTemporary,
              setProcesyElementowTemporary,
              procesList
            )
          }
        >
          Dodaj nowy proces
        </button>
      </div>
    </div>
  );
}


const ProcesName = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const contexApp = useContext(AppContext);
  // daneTechEdit = JSON.parse(JSON.stringify(daneTech))
  const procesListEdit = JSON.parse(JSON.stringify(contexApp.procesList))
  const procesList = contexApp.procesList;
  return (
    <td>
      <select
        className={style.select}
        value={row.nazwa_id}
        onChange={(e) => {
          // tutaj ma filtrować się lista wszystkich procesów która wyświetla się w Typie
          // nazwa_id powinna zmienić się chyba w Typie a nie tutaj
          let proc = procesList.filter(x=> x.nazwa_id == e.target.value).map(x=>{return x})
          contexModal.handleUpdateRowProcesyElementow({
            ...row,
            ...proc[0],
            nazwa_id: e.target.value,
             proces_id: procesListEdit.filter( proces => proces.nazwa_id == e.target.value)[0].id,
            update: true,
            historia: false,
            id:row.id
          });

          // console.log("Proces1 NAME: "+procesListEdit.filter( proces => proces.nazwa_id == e.target.value)[0].id)
        }}
      >
        {}
        {/* {contexApp.procesListName?.filter(x=>x.id !=6).map((option) => (
          <option key={option.id} value={option.id}>
            {option.nazwa}
          </option>
        ))} */}
        {            // tylko procesy produktowe czyli produkt == 1 
        Array.from(new Set(contexApp.procesList.filter((x) => x.produkt != 1).map((option) => option.nazwa)))
          // 2. Mapujemy po każdej unikalnej nazwie
          .map((unikalnaNazwa) => {
            // 3. Znajdujemy pierwszy obiekt w oryginalnej liście  pasujący do tej unikalnej nazwy, aby pobrać jego ID.
            const opcja = contexApp.procesList.find((opt) => opt.nazwa === unikalnaNazwa );
            // 4. Renderujemy opcję używając ID pierwszego pasującego elementu
            return (
              <option key={opcja.nazwa_id} value={opcja.nazwa_id}>
                {opcja.nazwa}
              </option>
            );
          })}





      </select>
    </td>
  );
};

const ProcessTyp = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const contexApp = useContext(AppContext);
  const selectedElementROW = contexModal.selectedElementROW;
  const procesList = contexApp.procesList;

  return (
    <td>
      <select
        className={style.select}
        value={row.proces_id}
        onChange={(e) => {
          console.log(e.target.value)
          let proc = procesList.filter(x=> x.id == e.target.value).map(x=>{return x})
          contexModal.handleUpdateRowProcesyElementow({
            ...row,
            ...proc[0],
            proces_id: e.target.value,
            update: true,
            historia: false,
            id:row.id
          });
          console.log("Proces1 TYP: "+e.target.value)
        }}
      >
        {}
        {contexApp.procesList
        .filter(p=> p.nazwa_id == contexModal.procesyElementowTemporary.filter(x=> x.element_id == selectedElementROW.id && x.indeks == row.indeks)[0].nazwa_id)

               .map((option) => (
          <option key={option.id} value={option.id}>
            {option.typ} {option.rodzaj} {option.wykonczenie} {option.obszar}
          </option>
        ))}
      </select>
    </td>
  );
};

const BackKolor = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
      className={style.select}
        value={row.back_kolor}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              back_kolor: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}

const FrontKolor = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
       className={style.select}
        value={row.front_kolor}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              front_kolor: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}
const INDEKS = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
        draggable={false}
        onDragStart={(e) => e.stopPropagation()}
        className={style.select_indeks}
        value={row.indeks}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              indeks: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      />
    </td>
  );
}
const IloscUzytkow = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
      className={style.select}
        value={row.ilosc_uzytkow}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              ilosc_uzytkow: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}

const FrontIlosc = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
      className={style.select}
        value={row.front_ilosc}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              front_ilosc: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}

const BackIlosc = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
      className={style.select}
        value={row.back_ilosc}
        onChange={(e) => {
          if (e.target.value === "" || reg_int.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              back_ilosc: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}

const Info = ({ row }) => {
  const contexModal = useContext(ModalInsertContext);
  const handleUpdateRowProcesyElementow = contexModal.handleUpdateRowProcesyElementow;
  return (
    <td>
      <input
      className={style.select}
        value={row.info}
        onChange={(e) => {
          if (e.target.value === "" || reg_txt.test(e.target.value)) {
            handleUpdateRowProcesyElementow({
              ...row,
              info: e.target.value,
              update: true,
              historia: false
            });
          }
        }}
      ></input>
    </td>
  );
}

function Usun({ row}) {
  const contexModal = useContext(ModalInsertContext);
  const procesyElementowTemporary = contexModal.procesyElementowTemporary;
  const setProcesyElementowTemporary = contexModal.setProcesyElementowTemporary;
  const elementy = contexModal.elementy;
  const daneZamowienia = contexModal.daneZamowienia;
    const [add] = useHistoria()
  return (
    <td className={style.col_button}>
      <div>
        <img
          className={style.expand}
          src={iconTrash}
          onClick={() => {

            if(row.zamowienie_id == 1){
              setProcesyElementowTemporary(procesyElementowTemporary.filter((p) => p.id !== row.id));

            }else{
           setProcesyElementowTemporary((prev) =>
              prev.map((t, a) => {
                if (t.id == row.id) {
                  return {
                    ...t,
                    delete: true
                  };
                } else {
                  return t;
                }
              })
            );

      

            }
          
 
      
          }}
          alt="Procesy"
        />
      </div>
    </td>
  );
}